var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"m-chat-file"},[(!_vm.loading)?_c('span',[_c('input',{attrs:{"id":"chatFileIpt","type":"file"},on:{"change":_vm.sendImage}}),_vm._v(" "),_vm._t("default")],2):_c('div',{staticStyle:{"float":"right","margin-right":"20px","display":"inline-block"}},[_c('Loading',{attrs:{"width":20}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e9a7808a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chat/ChatFile.vue
// module id = null
// module chunks = 